import React, { useState, useEffect, useRef } from 'react';
import Header from '../../components/common/Header';
import Button from '../../components/ui/Button';
import CountUp from '../../components/ui/CountUp'; // Import the new CountUp component
import LaptopScreenAnimation from '../../components/ui/LaptopScreenAnimation';
import PhotoFrame from '../../components/ui/PhotoFrame';
import "../../Website.css";
import CareerFooter from '../AboutUs/CareerFooter';
import { useNavigate } from 'react-router-dom';
const laptopImages = [
  '/images/4.2.png',
  '/images/Job Dashboard.png',
  // '/images/Insider Network.png',
  '/images/8.1.png',
  '/images/9.png',
];

const Home = () => {
  const [scrollY, setScrollY] = useState(0);
  const navigate = useNavigate()
  const handleStartJobHunting = () => {
    navigate("/sign-up")
  };


  const handleBrowseJobs = () => {
    navigate("/sign-up")
  };

  const handleStartSuccessStory = () => {
    navigate("/sign-up")
  };

  const getStartedSteps = [
    {
      number: '01',
      title: 'Upload Your \nResume',
      description: 'We will analyze it instantly',
    },
    {
      number: '02',
      title: 'Set Your \nGoals',
      description: 'Tell us what you are looking for',
    },
    {
      number: '03',
      title: 'Get \nMatched',
      description: 'Watch perfect opportunities roll in',
    },
  ];

  const totalGlowSteps = getStartedSteps.length * 2 - 1;
  const [activeGlowIndex, setActiveGlowIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveGlowIndex((prevIndex) => (prevIndex + 1) % totalGlowSteps);
    }, 1000);

    return () => clearInterval(interval);
  }, [totalGlowSteps]);

  useEffect(() => {
    const handleParallaxScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleParallaxScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleParallaxScroll);
    };
  }, []);



  const stats = [
    { value: '95%', label: 'resume ATS success rate' },
    { value: '100%', label: 'Free Forever' },
    { value: '3x', label: 'faster job placement' },
    { value: '4x', label: 'more interview invites' },
  ];

  const perfectForCategories = [
    {
      image: '/images/img_shutterstock2317887043_1.png',
      title: 'Professionals',
    },
    {
      image: '/images/img_shutterstock2353012835_1.png',
      title: 'International\nStudents',
    },
    {
      image: '/images/img_shutterstock1315451216_1.png',
      title: 'New Grads',
    },
    {
      image: '/images/img_shutterstock2534831851_1.png',
      title: 'Career\nSwitchers',
    },
  ];

  const faqs = [
    {
      question: 'How accurate are your AI job matches?',
      answer:
        'Our AI analyzes your skills, experience, and goals to deliver matches with 85%+ relevance scores —way better than generic job alerts.',
    },
    {
      question: 'How fast does the AI resume builder work?',
      answer:
        'Seconds. Upload your base resume, select a job, and get a tailored, ATS-optimized version instantly.',
    },
    {
      question: 'Do you help with cover letters too?',
      answer:
        'Yep! AI-generated, personalized cover letters that actually sound like you wrote them.',
    },
    {
      question: 'Can I track my job applications?',
      answer:
        'Everything`s tracked in your career dashboard—applications, skills progress, interview prep, the whole journey.',
    },
    {
      question: 'Can I use SeekJobs if I need visa sponsorship?',
      answer:
        'Yes! We have special filters for visa-friendly jobs and visa sponsorship opportunities.',
    },
    {
      question: 'What if I do not know what career I want?',
      answer:
        'Our career exploration tools and skill assessments help you discover paths that match your interests and strengths',
    },
  ];

  const featureRefs = useRef([]);
  const [stuckFeatures, setStuckFeatures] = useState({});
  const [expandedIndex, setExpandedIndex] = useState(null); // First open

  const toggleFAQ = (index) => {
    setExpandedIndex((prev) => (prev === index ? null : index));
  };
  useEffect(() => {
    // top-16 = 4rem = 64px.
    const stickyOffsetsInPx = [64, 80, 96, 112, 128];

    const handleScroll = () => {
      const newStuckState = {};
      featureRefs.current.forEach((ref, index) => {
        if (ref) {
          const rect = ref.getBoundingClientRect();
          newStuckState[index] = rect.top <= stickyOffsetsInPx[index] + 1;
        }
      });
      setStuckFeatures(newStuckState);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Common responsive classes for the imageSection container
  const imageSectionContainerClasses =
    'tw-relative tw-w-full tw-h-[280px] sm:tw-h-[350px] md:tw-h-[450px] lg:tw-h-[580px] tw-flex-shrink-0 tw-rounded-[24px] tw-overflow-hidden';

  const featuresData = [
    {
      title: 'Smart Matches',
      description:
        'Jobs that actually fit your vibe — no more "entry-level" roles requiring 5 years experience.',
      bgColor: 'tw-bg-global-4',
      textColor: 'tw-text-global-6',
      top: 'tw-top-16',
      zIndex: 'tw-z-0',
      rotation: 'tw-rotate-[2.45deg]',
      titleAlignment: 'tw-text-left',
      descriptionMaxWidth: 'tw-max-w-full lg:tw-max-w-[866px]',
      imageSection: (
        <div
          className={`${imageSectionContainerClasses} lg:tw-w-[620px] tw-bg-auto lg:tw-bg-contain tw-bg-no-repeat`}
          style={{
            backgroundImage: 'url(/images/img_path5335.png)',
          }}
        >
          <img
            src="/images/Frame 2018777014.png"
            alt="Match 2"
            className="tw-absolute tw-top-[28%] tw-left-[10%] tw-w-[90%] tw-h-auto tw-object-contain tw-rounded-[24px]"
          />
          <div className="tw-absolute tw-bottom-0 tw-left-[10%] tw-w-[90%] tw-h-[20%] tw-bg-gradient-to-t tw-from-[#1E1E1E] tw-to-transparent"></div>
        </div>
      ),
    },
    {
      title: 'AI Resume Magic',
      description:
        'Perfect, ATS-beating resumes in literal seconds. Upload once, customize for every job instantly.',
      bgColor: 'tw-bg-global-10',
      textColor: 'tw-text-global-1',
      top: 'tw-top-20',
      zIndex: 'tw-z-10',
      rotation: '-tw-rotate-[2.45deg]',
      titleAlignment: 'tw-text-left',
      descriptionMaxWidth: 'tw-max-w-full lg:tw-max-w-[925px]',
      imageSection: (
        <div
          className={`${imageSectionContainerClasses} lg:tw-w-[650px] tw-bg-right tw-bg-auto lg:tw-bg-contain tw-bg-no-repeat`}
          style={{
            backgroundImage: 'url(/images/img_path2675.png)',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <img
            src="/images/img-51.png"
            alt="Resume Preview"
            className="tw-absolute tw-top-[20%] tw-left-[5%] tw-w-[95%] tw-h-[85%] tw-rounded-[12px]"
          />
          <div className="tw-absolute tw-bottom-0 tw-left-[5%] tw-w-[95%] tw-h-[20%] tw-bg-gradient-to-t tw-from-[#FE7957] tw-to-transparent"></div>
        </div>
      ),
    },
    {
      title: 'Skill Gap Reality Check',
      description:
        'Know exactly what you are missing for any role. No more wondering why you did not get that callback.',
      bgColor: 'tw-bg-global-6',
      textColor: 'tw-text-global-1',
      top: 'tw-top-24',
      zIndex: 'tw-z-20',
      rotation: 'tw-rotate-[2.45deg]',
      titleAlignment: 'tw-text-left',
      descriptionMaxWidth: 'tw-max-w-full lg:tw-max-w-[921px]',
      imageSection: (
        <div className={`${imageSectionContainerClasses} lg:tw-w-[652px]`}>
          <div
            className="tw-w-full tw-h-full"
            style={{
              backgroundImage: 'url(/images/img_path6747.png)',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
            }}
          >
            <img
              src="/images/img_image_54.png"
              alt="Skill Analysis"
              className="
              tw-absolute tw-top-[10%] tw-left-[60%] tw-w-[40%] tw-h-[60%]
              sm:tw-top-[12%] sm:tw-left-[65%] sm:tw-w-[35%] sm:tw-h-[65%]
              md:tw-top-[17%] md:tw-left-[76%] md:tw-w-[30%] md:tw-h-[70%]
              lg:tw-top-[15%] lg:tw-left-[73%] lg:tw-w-[36%] lg:tw-h-[70%]
              tw-object-contain
            "
            />
            <img
              src="/images/img_image_52.png"
              alt="Skills Chart"
              className="
              tw-absolute tw-top-[18%] tw-left-[5%] tw-w-[55%] tw-h-[65%]
              sm:tw-top-[20%] sm:tw-left-[2%] sm:tw-w-[50%] sm:tw-h-[70%]
              md:tw-top-[22%] md:tw-left-[30%] md:tw-w-[45%] md:tw-h-[75%]
              lg:tw-top-[24%] lg:tw-left-[0%] lg:tw-w-[63%] lg:tw-h-[75%]
              tw-object-contain
            "
            />
            <div className="tw-absolute tw-bottom-0 tw-left-[0%] tw-w-[100%] tw-h-[20%] tw-bg-gradient-to-t tw-from-[#7978d1] tw-to-transparent tw-rounded-[24px]"></div>
          </div>
        </div>
      ),
    },
    {
      title: 'Insider Access',
      description:
        'Connect directly with hiring teams and employees. Because networking should not feel impossible.',
      bgColor: 'tw-bg-global-9',
      textColor: 'tw-text-global-1',
      top: 'tw-top-28',
      zIndex: 'tw-z-30',
      rotation: '-tw-rotate-[2.45deg]',
      titleAlignment: 'tw-text-left',
      descriptionMaxWidth: 'tw-max-w-full lg:tw-max-w-[925px]',
      imageSection: (
        <div
          className={`${imageSectionContainerClasses} lg:tw-w-[699px]`}
          style={{
            backgroundImage: 'url(/images/img_path939.png)',
            backgroundSize: 'auto',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'top',
          }}
        >
          <img
            src="/images/img_image_41.png"
            alt="Network Preview"
            className="tw-absolute tw-top-[10%] tw-left-[20%] tw-w-[91%] tw-h-[95%] tw-object-contain tw-rounded-[12px]"
          />
          <img
            src="/images/img_image_10.png"
            alt="Network Chat"
            className="tw-absolute tw-top-[28%] tw-left-[0%] tw-w-[95%] tw-h-[30%] tw-object-contain"
          />
          <div className="tw-absolute tw-bottom-0 tw-left-[30%] tw-w-[70%] tw-h-[20%] tw-bg-gradient-to-t tw-from-[#F4B8D6] tw-to-transparent tw-rounded-[24px]"></div>
        </div>
      ),
    },
    {
      title: 'Career Dashboard',
      description:
        'Track your wins, spot patterns, and optimize your hunt with data that actually helps.',
      bgColor: 'tw-bg-global-5',
      textColor: 'tw-text-global-6',
      top: 'tw-top-32',
      zIndex: 'tw-z-40',
      rotation: 'tw-rotate-[2.45deg]',
      titleAlignment: 'tw-text-left',
      descriptionMaxWidth: 'tw-max-w-full lg:tw-max-w-[925px]',
      imageSection: (
        <div
          className={`${imageSectionContainerClasses} lg:tw-w-[699px]`}
          style={{
            backgroundImage: 'url(/images/path7835.png)',
            backgroundSize: 'auto',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <img
            src="/images/image-29.png"
            alt="Dashboard"
            className="tw-absolute tw-top-[37%] tw-left-[28%] tw-w-[90%] tw-right-0 tw-h-auto tw-object-contain"
          />
          <div className="tw-absolute tw-bottom-0 tw-left-[28%] tw-w-[90%] tw-h-[20%] tw-bg-gradient-to-t tw-from-[#323232] tw-to-transparent"></div>
        </div>
      ),
    },
  ];


  return (
    <div style={{ marginTop: "65px" }} className="tw-min-h-screen">

      {/* This div creates the fixed background with a parallax effect.
          It's positioned behind all other content. */}
      <div
        className="tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-screen -tw-z-10"
        style={{
          backgroundColor: '#070709', // Fallback
          backgroundImage: `radial-gradient(rgba(126, 130, 153, 0.8) 1px, transparent 1px), linear-gradient(to bottom, #081933, #070709)`,
          backgroundSize: `30px 30px, 100% 100%`,
        }}
      />

      <Header />

      {/* Hero Section */}
      <section
        className=" tw-relative tw-w-full tw-h-[640px] sm:tw-h-[720px] md:tw-h-[925px] tw-overflow-hidden tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-20 tw-pb-12 md:tw-pb-0 tw-bg-cover tw-bg-center"
        style={{
          backgroundImage: `linear-gradient(to bottom, rgba(8, 25, 51, 0.0), rgba(7, 7, 9, 0.7)), url(/images/img_g1.png)`, marginTop: "60px"
        }}
      >
        <div className="tw-absolute tw-inset-0">
          {/* Background Images */}
          <div className="tw-relative tw-z-10 tw-flex tw-flex-col tw-items-start md:tw-items-center tw-justify-center tw-top-[60px] tw-px-4 md:tw-px-0">
            {/* Main text content and buttons */}
            <div className="tw-w-full tw-text-left md:tw-text-center tw-mb-8 md:tw-mb-16">
              <h1
                className="tw-font-inter tw-font-semibold tw-text-4xl sm:tw-text-5xl md:tw-text-6xl lg:tw-text-7xl xl:tw-text-7xl 2xl:tw-text-7xl 3xl:tw-text-8xl tw-leading-tight tw-text-global-6 tw-tracking-tight-4"
                style={{ textShadow: '0px 0px 50px #3076ce' }}
              >
                Finally, a Job Platform That Gets It
              </h1>
              <p
                className="tw-font-inter tw-font-semibold tw-text-base sm:tw-text-lg md:tw-text-xl lg:tw-text-2xl xl:tw-text-2xl 2xl:tw-text-2xl 3xl:tw-text-3xl tw-leading-snug tw-text-global-6 tw-max-w-6xl md:tw-mx-auto tw-mt-4 tw-tracking-tight-4 lg:tw-max-w-none"
              >
                Stop scrolling through endless job boards. Let us find opportunities that actually
                match your goals.
              </p>
            </div>
            <div className="tw-flex tw-flex-col tw-space-y-4 md:tw-flex-row md:tw-space-x-4 md:tw-space-y-0 tw-w-full md:tw-w-auto tw-justify-start md:tw-justify-center">
              {/* Responsive button layout */}

              <button onClick={handleStartJobHunting} className="tw-border-none tw-text-[16px] tw-inline-block tw-bg-gradient-to-r tw-from-[#0843FE] tw-to-[#4995FB] tw-text-white tw-font-medium tw-py-3 tw-px-8 tw-rounded-md tw-transition tw-duration-300 tw-ease-in-out">
                Start Job Hunting Now
              </button>
              <button
                className="tw-text-[16px] tw-bg-white tw-text-black tw-border tw-border-white tw-font-semibold tw-py-3 tw-px-8 tw-rounded-lg tw-transition tw-duration-300 hover:tw-bg-black hover:tw-text-white"
                onClick={handleStartJobHunting}
              >
                Try for Free
              </button>
            </div>
            {/* Mobile-only Laptop Animation */}
            <div className="tw-mt-12 tw-w-full tw-max-w-sm sm:tw-max-w-md tw-mx-auto md:tw-hidden">
              <LaptopScreenAnimation images={laptopImages} />
            </div>
          </div>
          {/* Background container with z-0 */}
          <div className="tw-container tw-mx-auto tw-absolute tw-inset-0 tw-z-0 tw-flex tw-justify-center tw-hidden md:tw-block">
            <div className="tw-relative tw-w-full tw-h-full [perspective:1000px]">
              {/* Right PhotoFrame */}
              <div
                className="tw-absolute tw-top-[53%] tw-right-[0%] md:tw-right-[0%] lg:tw-right-[0%] xl:tw-right-[0%] tw-w-[250px] tw-h-[370px] tw-z-30 lg:tw-top-[550px] md:tw-hidden lg:tw-inline-block [transform-style:preserve-3d]"
                style={{ transform: `translateY(${scrollY * -0.25}px)` }}
              >
                <PhotoFrame
                  src="/images/Hero-img-r2.jpeg"
                  alt="Professional using a laptop"
                  containerClassName="tw-w-full tw-h-full [transform:rotateY(-45deg)]"
                />
              </div>
              {/* Center background image */}
              <div
                className="tw-absolute tw-top-[35%] tw-left-[0%] tw-w-[95%] tw-h-[61%] lg:tw-top-[410px] lg:tw-w-[1381px] lg:tw-h-[606px] tw-z-20"
                style={{
                  backgroundImage: 'url(/images/img_path4157.png)',
                  backgroundSize: 'contain',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                  transform: `translateY(${scrollY * -0.05}px)`,
                }}
              />
              {/* Left PhotoFrame */}
              <div
                className="tw-absolute tw-top-[53%] tw-left-[0%] md:tw-left-[0%] lg:tw-left-[0%] xl:tw-left-[0%] tw-w-[250px] tw-h-[370px] tw-z-10 lg:tw-top-[550px] md:tw-hidden lg:tw-inline-block [transform-style:preserve-3d]"
                style={{ transform: `translateY(${scrollY * -0.2}px)` }}
              >
                <PhotoFrame
                  src="/images/Hero-img-l.jpeg"
                  alt="A recent graduate in a professional setting"
                  containerClassName="tw-w-full tw-h-full [transform:rotateY(45deg)]"
                />
              </div>
              {/* LaptopScreenAnimation center */}
              <div
                className="tw-absolute tw-top-[43%] tw-left-1/2 tw-w-[90%] tw-max-w-[850px] tw-h-[250px] sm:tw-h-[350px] md:tw-h-[500px] tw-z-40 lg:tw-top-[445px]"
                style={{ transform: `translateX(-50%)` }}
              >
                <LaptopScreenAnimation images={laptopImages} />
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Features Section */}
      <section className="tw-py-16 md:tw-py-24 lg:tw-py-32">
        {/* Responsive padding */}
        <div className="tw-px-4 md:tw-px-8 lg:tw-px-16 xl:tw-px-32">
          {/* Responsive padding */}
          <h2
            className="font-inter font-semibold tw-text-3xl sm:tw-text-4xl md:tw-text-5xl lg:tw-text-6xl xl:tw-text-5xl 2xl:tw-text-5xl 3xl:tw-text-6xl tw-leading-tight md:tw-leading-[77px] tw-text-global-6 tw-text-center tw-mb-8 md:tw-mb-16 tracking-tight-4"
            style={{ textShadow: '0px 0px 50px #3076ce' }}
          >
            Why Your Job Hunt Just Got 10x Easier
          </h2>
          <div className="tw-space-y-16 md:tw-space-y-32 lg:tw-space-y-48">
            {/* Responsive vertical spacing */}
            {featuresData.map((feature, index) => (
              <div
                key={feature.title}
                ref={(el) => (featureRefs.current[index] = el)}
                className={`tw-sticky ${feature.top} ${feature.zIndex} ${feature.bgColor} tw-rounded-[32px] tw-pl-4 md:tw-pl-6 lg:tw-pl-8 tw-flex tw-flex-col lg:tw-flex-row tw-items-center lg:tw-items-center tw-justify-center lg:tw-justify-between tw-transition-all tw-duration-500 tw-ease-in-out tw-h-auto tw-min-h-[500px] lg:tw-min-h-[580px] tw-space-y-6 lg:tw-space-y-0 ${stuckFeatures[index] ? 'tw-rotate-0' : feature.rotation
                  }`}
              >
                <div className="tw-flex-1 tw-flex tw-flex-col tw-justify-between tw-self-stretch tw-text-left tw-py-12 tw-px-6">
                  <h3
                    className={`font-inter font-semibold tw-text-3xl sm:tw-text-4xl md:tw-text-5xl lg:tw-text-5xl xl:tw-text-5xl 2xl:tw-text-5xl 3xl:tw-text-6xl tracking-tight-4 tw-leading-tight md:tw-leading-[78px] ${feature.textColor} ${feature.titleAlignment}`}
                  >
                    {feature.title}
                  </h3>
                  <p
                    className={`font-inter font-semibold tw-text-lg sm:tw-text-xl md:tw-text-2xl lg:tw-text-xl xl:tw-text-2xl 2xl:tw-text-2xl 3xl:tw-text-3xl tw-leading-normal md:tw-leading-[48px] ${feature.textColor} ${feature.descriptionMaxWidth} tw-mt-6 tracking-tight-4`}
                  >
                    {feature.description}
                  </p>
                </div>
                {feature.imageSection}
              </div>
            ))}
          </div>
          <div className="tw-text-center tw-mt-8 md:tw-mt-16">
            <button onClick={handleStartJobHunting} className="tw-text-[16px] tw-border-none tw-inline-block tw-bg-gradient-to-r tw-from-[#0843FE] tw-to-[#4995FB] tw-text-white tw-font-medium tw-py-3 tw-px-8 tw-rounded-md tw-transition tw-duration-300 tw-ease-in-out">
              Try SeekJobs for Free
            </button>
          </div>
        </div>
      </section>


      {/* Comparison Section */}
      <section>
        <div className="tw-bg-gradient-to-b tw-from-[#11356d] tw-to-[#08172f] tw-py-8 md:tw-py-16 tw-overflow-hidden">
          {/* Responsive padding */}
          <h2
            className="font-inter font-semibold tw-text-3xl sm:tw-text-4xl md:tw-text-5xl lg:tw-text-6xl xl:tw-text-5xl 2xl:tw-text-5xl 3xl:tw-text-6xl tw-leading-tight md:tw-leading-[77px] tw-text-global-6 tw-text-center tw-mb-8 md:tw-mb-16 tw-tracking-tight-4"
            style={{ textShadow: '0px 0px 50px #3076ce' }}
          >
            Job Hunting Should not Suck!
          </h2>
          <div className="tw-space-y-4 md:tw-space-y-8">
            {/* Responsive vertical spacing */}
            <div className="tw-overflow-hidden">
              <div
                className="tw-flex tw-flex-nowrap tw-animate-marquee-left"
                style={{ '--marquee-duration': '40s' }}
              >
                {Array(6)
                  .fill(0)
                  .map((_, index) => (
                    <span
                      key={`old-way-label-${index}`}
                      className="font-inter font-semibold tw-text-xl md:tw-text-2xl lg:tw-text-3xl xl:tw-text-2xl 2xl:tw-text-2xl 3xl:tw-text-3xl tw-leading-normal md:tw-leading-[39px] tw-text-global-7 tw-flex-shrink-0 tw-px-4 md:tw-px-8 tw-tracking-tight-4"
                    >
                      Old Way
                    </span>
                  ))}
                {Array(6)
                  .fill(0)
                  .map((_, index) => (
                    <span
                      key={`old-way-label-dup-${index}`}
                      className="font-inter font-semibold tw-text-xl md:tw-text-2xl lg:tw-text-3xl xl:tw-text-2xl 2xl:tw-text-2xl 3xl:tw-text-3xl tw-leading-normal md:tw-leading-[39px] tw-text-global-7 tw-flex-shrink-0 tw-px-4 md:tw-px-8 tw-tracking-tight-4"
                    >
                      Old Way
                    </span>
                  ))}
              </div>
            </div>
            <p
              className="font-inter font-semibold tw-text-3xl sm:tw-text-4xl md:tw-text-5xl lg:tw-text-6xl xl:tw-text-7xl 2xl:tw-text-7xl 3xl:tw-text-8xl tw-leading-tight md:tw-leading-[117px] tw-text-global-7 tw-tracking-tight-4"
            >
              {/* Responsive font size */}
              <span
                className="tw-whitespace-nowrap tw-inline-block tw-animate-marquee-left"
                style={{ '--marquee-duration': '30s' }}
              >
                <span>Apply to 100 jobs → Get 2 responses → Wonder what went wrong</span>
                <span className="tw-inline-block tw-w-[50px] md:tw-w-[100px]"></span> {/* Spacer */}
                <span>Apply to 100 jobs → Get 2 responses → Wonder what went wrong</span>
              </span>
            </p>
            {/* SeekJobs Way Labels */}
            <div className="tw-overflow-hidden">
              <div
                className="tw-flex tw-flex-nowrap tw-animate-marquee-left"
                style={{ '--marquee-duration': '40s' }}
              >
                {Array(5)
                  .fill(0)
                  .map((_, index) => (
                    <span
                      key={`seekjobs-way-label-${index}`}
                      className="font-inter font-semibold tw-text-xl md:tw-text-2xl lg:tw-text-3xl xl:tw-text-2xl 2xl:tw-text-2xl 3xl:tw-text-3xl tw-leading-normal md:tw-leading-[39px] tw-text-global-4 tw-flex-shrink-0 tw-px-4 md:tw-px-8 tw-tracking-tight-4"
                    >
                      SeekJobs Way
                    </span>
                  ))}
                {/* Duplicate content for seamless loop */}
                {Array(5)
                  .fill(0)
                  .map((_, index) => (
                    <span
                      key={`seekjobs-way-label-dup-${index}`}
                      className="font-inter font-semibold tw-text-xl md:tw-text-2xl lg:tw-text-3xl xl:tw-text-2xl 2xl:tw-text-2xl 3xl:tw-text-3xl tw-leading-normal md:tw-leading-[39px] tw-text-global-4 tw-flex-shrink-0 tw-px-4 md:tw-px-8 tw-tracking-tight-4"
                    >
                      SeekJobs Way
                    </span>
                  ))}
              </div>
            </div>
            {/* SeekJobs Way Description */}
            <p
              className="font-inter font-semibold tw-text-3xl sm:tw-text-4xl md:tw-text-5xl lg:tw-text-6xl xl:tw-text-7xl 2xl:tw-text-7xl 3xl:tw-text-8xl tw-leading-tight md:tw-leading-[117px] tw-text-global-6 tracking-tight-4"
            >
              {/* Responsive font size */}
              <span
                className="tw-whitespace-nowrap tw-inline-block tw-animate-marquee-left"
                style={{ '--marquee-duration': '30s' }}
              >
                <span>
                  Get matched to 10 perfect roles → Land 3 interviews → Choose your favorite
                </span>
                <span className="tw-inline-block tw-w-[50px] md:tw-w-[100px]"></span> {/* Spacer */}
                <span>
                  Get matched to 10 perfect roles → Land 3 interviews → Choose your favorite
                </span>
              </span>
            </p>
          </div>
        </div>
      </section>


      {/* Combined Stats and Perfect For Section */}
      <div
        className="relative tw-bg-cover tw-bg-center tw-bg-scroll md:tw-bg-fixed" // Responsive background attachment
        style={{
          backgroundImage: `linear-gradient(to bottom, rgba(8, 25, 51, 0.3), rgba(7, 7, 9, 0.6)), url(/images/img_g1.png)`,
        }}
      >
        {/* Stats Section */}
        <section className="tw-py-16 md:tw-py-24 lg:tw-py-32">
          <div className="tw-px-4 md:tw-px-8 lg:tw-px-16 xl:tw-px-32">
            <h2
              className="font-inter font-semibold tw-text-4xl sm:tw-text-5xl md:tw-text-6xl lg:tw-text-7xl xl:tw-text-7xl 2xl:tw-text-7xl 3xl:tw-text-8xl tw-leading-tight md:tw-leading-[121px] tw-text-global-6 tw-text-center tw-mb-8 md:tw-mb-16 tracking-tight-4"
              style={{ textShadow: '0px 0px 50px #3076ce' }}
            >
              The Stats That Matter
            </h2>

            <div className="tw-grid tw-grid-cols-2 tw-gap-y-8 md:tw-flex md:tw-justify-between max-w-[1405px] tw-mx-auto">
              {/* Responsive grid/flex layout */}
              {stats.map((stat, index) => (
                <div key={index} className="tw-text-left">
                  <div
                    className="font-inter font-semibold tw-text-4xl sm:tw-text-5xl md:tw-text-6xl lg:tw-text-7xl xl:tw-text-7xl 2xl:tw-text-7xl 3xl:tw-text-8xl tw-leading-tight md:tw-leading-[117px] tw-text-global-3 tw-mb-2 md:tw-mb-4 tabular-nums tracking-tight-4"
                  >
                    <CountUp value={stat.value} duration={2000} />
                  </div>
                  <div
                    className="font-inter font-semibold tw-text-base sm:tw-text-lg md:tw-text-xl lg:tw-text-2xl xl:tw-text-2xl 2xl:tw-text-2xl 3xl:tw-text-3xl tw-leading-normal md:tw-leading-[38px] tw-text-global-5 max-w-[310px] tracking-tight-4"
                  >
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Perfect For Section */}
        <section
          className="tw-py-8 md:tw-py-12 lg:tw-py-16"
          style={{
            backgroundImage: 'url(/images/img_vector_3.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'top',
          }}
        >
          <div className="tw-px-4 md:tw-px-8 lg:tw-px-16 xl:tw-px-32 tw-tracking-tight-4">
            <div className="tw-text-center tw-mb-8 md:tw-mb-16">
              <p
                className="font-inter font-semibold tw-text-lg sm:tw-text-xl md:tw-text-2xl lg:tw-text-3xl xl:tw-text-2xl 2xl:tw-text-2xl 3xl:tw-text-3xl tw-leading-normal md:tw-leading-[38px] tw-text-global-6 max-w-[687px] tw-mx-auto tracking-tight-4"
              >
                Your Success Story Starts Here
              </p>
              <p
                className="font-inter font-semibold tw-text-lg sm:tw-text-xl md:tw-text-2xl lg:tw-text-3xl xl:tw-text-2xl 2xl:tw-text-2xl 3xl:tw-text-3xl tw-leading-normal md:tw-leading-[38px] tw-text-global-6 max-w-[687px] tw-mx-auto tracking-tight-4 tw-mb-4 md:tw-mb-8"
              >
                Ready to stop job hunting and start job winning?
              </p>
              <h2
                className="font-inter font-semibold tw-text-3xl sm:tw-text-4xl md:tw-text-5xl lg:tw-text-6xl xl:tw-text-5xl 2xl:tw-text-5xl 3xl:tw-text-6xl tw-leading-tight md:tw-leading-[78px] tw-text-black tw-mb-4 md:tw-mb-8"
              >
                Perfect For
              </h2>
            </div>

            <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-8 tw-mb-8 md:tw-mb-16">
              {/* Responsive grid layout */}
              {perfectForCategories.map((category, index) => (
                <div
                  key={index}
                  className="tw-relative tw-bg-global-8 tw-rounded-[12px] tw-shadow-lg tw-overflow-hidden tw-w-full tw-h-[300px] sm:tw-h-[400px] tw-min-h-[400px] tw-transition-all tw-duration-300 hover:tw-scale-105 tw-cursor-pointer hover:tw-shadow-2xl hover:tw-shadow-blue-500/50"
                >
                  <img
                    src={category.image}
                    alt={category.title}
                    className="tw-w-full tw-h-full tw-object-cover"
                  />
                  <div className="tw-absolute tw-inset-0 tw-flex tw-items-end tw-justify-start tw-p-4 md:tw-p-8 tw-bg-gradient-to-t tw-from-black/50 tw-to-transparent">
                    <h3
                      className="font-inter font-semibold tw-text-xl sm:tw-text-2xl md:tw-text-3xl lg:tw-text-4xl xl:tw-text-3xl 2xl:tw-text-3xl 3xl:tw-text-4xl tw-leading-[100%] tw-text-global-6 tw-text-left tw-whitespace-pre-line tracking-tight-4"
                    >
                      {category.title}
                    </h3>
                  </div>
                </div>
              ))}
            </div>

            <div className="tw-text-center tw-mb-8 md:tw-mb-16">
              <h2
                className="font-inter font-semibold tw-text-3xl sm:tw-text-4xl md:tw-text-5xl lg:tw-text-6xl xl:tw-text-5xl 2xl:tw-text-5xl 3xl:tw-text-6xl tw-leading-tight md:tw-leading-[78px] tw-text-global-6 tw-mb-4 md:tw-mb-8 tracking-tight-4"
              >
                Get Started in 60 Seconds
              </h2>
            </div>

            <div className="tw-flex tw-flex-col lg:tw-flex-row tw-justify-center tw-items-center tw-gap-8 lg:tw-gap-4 tw-mb-8 md:tw-mb-16 tw-tracking-tight-4">
              {/* Responsive layout for steps */}
              {getStartedSteps.map((step, index) => {
                const cardIsActive = activeGlowIndex === index * 2;
                const arrowIsActive = activeGlowIndex === index * 2 + 1;

                return (
                  <React.Fragment key={step.number}>
                    <div
                      className={`tw-relative tw-rounded-[12px] tw-p-4 md:tw-p-8 tw-w-full lg:tw-flex-1 lg:tw-max-w-md xl:tw-max-w-lg tw-h-auto lg:tw-h-[239px] tw-transition-all tw-duration-500 tw-ease-in-out tw-bg-gradient-to-br tw-from-[#ffffff7f] tw-to-[#9999997f] ${cardIsActive
                        ? 'tw-border-2 tw-border-global-3 tw-shadow-2xl tw-shadow-blue-500/50'
                        : 'tw-border-2 tw-border-global-7 tw-shadow-lg'
                        }`}
                    >
                      <div
                        className={`tw-absolute tw-inset-0 tw-rounded-[12px] tw-bg-white tw-transition-opacity tw-duration-500 tw-ease-in-out ${cardIsActive ? 'tw-opacity-100' : 'tw-opacity-0'
                          }`}
                      ></div>
                      <div className="tw-relative">
                        <div
                          className="font-inter font-semibold tw-text-xl md:tw-text-2xl lg:tw-text-3xl xl:tw-text-2xl 2xl:tw-text-2xl 3xl:tw-text-3xl tw-leading-normal md:tw-leading-[39px] tw-mb-2 md:tw-mb-4 tw-transition-colors tw-duration-500 tw-text-global-2"
                        >
                          {step.number}
                        </div>
                        <h3
                          className={`font-inter font-semibold tw-text-xl md:tw-text-2xl lg:tw-text-3xl xl:tw-text-2xl 2xl:tw-text-2xl 3xl:tw-text-3xl tw-leading-normal md:tw-leading-[38px] tw-mb-2 md:tw-mb-4 tw-transition-colors tw-duration-500 tw-whitespace-pre-line ${cardIsActive ? 'tw-text-global-3' : 'tw-text-global-6'
                            } tracking-tight-4`}
                        >
                          {step.title}
                        </h3>
                        <p
                          className="font-inter font-semibold tw-text-base md:tw-text-lg lg:tw-text-xl xl:tw-text-lg 2xl:tw-text-lg 3xl:tw-text-xl tw-leading-normal md:tw-leading-[30px] tw-text-global-2 tw-transition-colors tw-duration-500 tracking-tight-4"
                        >
                          {step.description}
                        </p>
                      </div>
                    </div>
                    {index < getStartedSteps.length - 1 && (
                      <img
                        src="/images/img_arrow_right.png"
                        alt="arrow"
                        className={`tw-w-16 tw-h-auto tw-transition-all tw-duration-500 tw-ease-in-out ${arrowIsActive
                          ? 'tw-scale-110 tw-opacity-100 tw-drop-shadow-[0_0_15px_rgba(59,130,246,0.5)]'
                          : 'tw-opacity-50'
                          } tw-rotate-90 lg:tw-rotate-0 tw-ml-0 lg:tw-ml-[-16px]`}
                      />
                    )}
                  </React.Fragment>
                );
              })}
            </div>

            <div className="tw-flex tw-flex-col tw-space-y-4 sm:tw-flex-row sm:tw-space-x-4 sm:tw-space-y-0 tw-justify-center">
              {/* Responsive button layout */}

              <button
                className="tw-text-[16px] tw-bg-white tw-text-black tw-border tw-border-white tw-font-semibold tw-py-3 tw-px-8 tw-rounded-lg tw-transition tw-duration-300 hover:tw-bg-black hover:tw-text-white"
                onClick={() => navigate('/sign-up')}
              >
                Create your profile now
              </button>
              <button
                onClick={handleBrowseJobs}
                className="tw-text-[16px] tw-font-inter tw-font-semibold tw-text-white tw-border tw-border-white tw-bg-transparent tw-px-4 tw-py-3 tw-rounded-lg hover:tw-bg-white hover:tw-text-black tw-transition-colors"
              >
                Browse jobs
              </button>

            </div>
          </div>
        </section>
      </div>


      {/* FAQ Section */}
      <section className="tw-py-20">
        <div className="tw-px-4 sm:tw-px-6 lg:tw-px-32">
          <div className="tw-relative">
            <h2
              className="tw-font-inter tw-font-semibold tw-text-[36px] sm:tw-text-[48px] lg:tw-text-[66px] tw-leading-[44px] sm:tw-leading-[58px] lg:tw-leading-[80px] tw-text-global-6 tw-text-center tw-mb-10 sm:tw-mb-14 lg:tw-mb-16"
              style={{ textShadow: "0px 0px 50px #3076ce" }}
            >
              Frequently Asked Questions
            </h2>

            <div className="tw-space-y-3">
              {faqs.map((faq, index) => (
                <div key={index}>
                  <div
                    onClick={() => toggleFAQ(index)}
                    className={`tw-rounded-[12px] tw-cursor-pointer tw-transition-all ${expandedIndex === index ? "tw-bg-global-2" : ""
                      }`}
                    style={{ padding: "10px" }}
                  >
                    <div className="tw-flex tw-justify-between tw-items-center">
                      <h3 className="tw-font-inter tw-font-semibold tw-text-[16px] sm:tw-text-[18px] lg:tw-text-[19px] tw-leading-[24px] sm:tw-leading-[26px] tw-text-global-6">
                        {faq.question}
                      </h3>
                      {expandedIndex === index && (<img
                        src="/images/img_caret.svg"
                        alt="Toggle"
                        className={`tw-w-5 sm:tw-w-6 tw-h-5 sm:tw-h-6 tw-transition-transform `}
                      />)}
                      {expandedIndex !== index && (<img
                        src="/images/img_caret.svg"
                        alt="Toggle"
                        className={`tw-w-5 sm:tw-w-6 tw-h-5 sm:tw-h-6 tw-transition-transform tw-rotate-180`}
                      />)}
                    </div>

                    {expandedIndex === index && (
                      <p className="tw-font-inter tw-font-medium tw-text-[14px] sm:tw-text-[16px] lg:tw-text-[19px] tw-leading-[22px] sm:tw-leading-[26px] tw-text-global-6 tw-mt-3 tw-pl-3 sm:tw-pl-6 lg:tw-pl-10">
                        {faq.answer}
                      </p>
                    )}
                  </div>


                  {index < faqs.length - 1 && (
                    <div className="tw-bg-global-7 tw-h-px tw-w-full tw-my-4"></div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>


      {/* Final CTA Section */}
      <section className="tw-bg-gradient-to-b tw-from-[#081933] tw-to-[#184b99] tw-rounded-[12px] tw-relative tw-overflow-hidden">
        {/* Responsive margin */}
        <img
          src="/images/img_image_8.png"
          alt="Background"
          className="tw-absolute inset-0 tw-w-full tw-h-full tw-object-cover"
        />
        <div className="tw-absolute tw-inset-0 tw-bg-gradient-to-b tw-from-[#081933]/70 tw-to-[#184b99]/70"></div>
        <div className="tw-relative z-10 tw-py-8 md:tw-py-16 tw-px-4 md:tw-px-8 lg:tw-px-16 xl:tw-px-32 tw-text-center">
          {/* Responsive padding */}
          <h2
            className="font-inter font-semibold tw-text-3xl sm:tw-text-4xl md:tw-text-5xl lg:tw-text-6xl xl:tw-text-5xl 2xl:tw-text-5xl 3xl:tw-text-6xl tw-leading-tight md:tw-leading-[77px] tw-text-global-6 tw-mb-4 md:tw-mb-8 tw-tracking-tight-4"
            style={{ textShadow: '0px 0px 16px rgba(255, 255, 255, 0.5)' }}
          >
            Still Job Hunting the Hard Way? Time to level up.
          </h2>
          <Button
            variant="tertiary"
            onClick={handleStartSuccessStory}
            className="tw-px-4 tw-py-3 tw-rounded-lg tw-text-[16px]"
          >
            Start Your Success Story
          </Button>
        </div>
      </section>


      <CareerFooter theme="dark" />
    </div>
  );
};

export default Home;
